import { api } from './customers'

export interface IVFJourney {
    id: number;
    journeyStageName: string;
    description: string;
    activeStatus: any;
    createdBy: any;
    updatedBy: any;
    createdAt: any,
    updatedAt: any,
    steps: any

}
export interface IVFJourneymaster {
   data:any

}

type IVFJourneysResponse = IVFJourney[];

export const JourneyApi = api.injectEndpoints({
    endpoints: (build) => ({

        getIVFJourneys: build.query<IVFJourneysResponse, any>({
            query: ({ pageNo, name }) =>
                `customer_ivf_journey?page=${pageNo}&filter=${name}`,
        }),
        
        getIVFJourneymaster: build.query<IVFJourneymaster, any>({
            query: ({id}) =>
                `customer_ivf_journey_active?customerId=${id}`,
        }),
        addIVFJourney: build.mutation<IVFJourney, any>({
            query: (body) => ({
                url: `customer_ivf_journey`,
                method: 'POST',
                body,
            }),
            transformResponse: (response: { data: IVFJourney }, meta, arg) => response.data,
        }),
        addIVFJourneyHistory: build.mutation<IVFJourney, any>({
            query: (body) => ({
                url: `customer_ivf_journey_history`,
                method: 'POST',
                body,
            }),
            transformResponse: (response: { data: IVFJourney }, meta, arg) => response.data,
        }),
        getIVFJourney: build.query<IVFJourney, string>({
            query: (id) => `get_IVFJourneyBycustomerID/${id}`,
            transformResponse: (response: { data: IVFJourney }, meta, arg) => response.data,
        }),
        getIVFJourneyCurrentStage: build.query<IVFJourney, any>({
            query: ({id}) => `customer_ivf_journey_history/${id}`,
            transformResponse: (response: { data: IVFJourney }, meta, arg) => response.data,
        }),
        updateIVFJourney: build.mutation<void, Pick<IVFJourney, 'id'> & Partial<IVFJourney>>({
            query: ({ id, ...patch }) => ({
                url: `customer_ivf_journey/${id}`,
                method: 'PUT',
                body: patch,
            }),
        }),
        updateIVFJourneystep: build.mutation<void, Pick<IVFJourney, 'id'> & Partial<IVFJourney>>({
            query: ({ id, ...patch }) => ({
                url: `customer_ivf_journey/step/${id}`,
                method: 'PUT',
                body: patch,
            }),
        }),
        deleteIVFJourney: build.mutation<{ success: boolean; id: number }, number>({
            query(id) {
                return {
                    url: `customer_ivf_journey/${id}`,
                    method: 'DELETE',
                }
            },
        }),
        deleteIVFJourneystep: build.mutation<{ success: boolean; id: number }, number>({
            query(id) {
                return {
                    url: `customer_ivf_journey_step/${id}`,
                    method: 'DELETE',
                }
            },
        }),
    }),
})

export const {
    useGetIVFJourneyQuery,
    useGetIVFJourneysQuery,
    useGetIVFJourneymasterQuery,
    useAddIVFJourneyMutation,
    useGetIVFJourneyCurrentStageQuery,
    useAddIVFJourneyHistoryMutation,
    useUpdateIVFJourneyMutation,
    useUpdateIVFJourneystepMutation,
    useDeleteIVFJourneyMutation,
    useDeleteIVFJourneystepMutation
} = JourneyApi;
